import type { UtmData } from '~/schemas/utm'
import { fetchApi } from './helpers'

/**
 * A signup Klaviyo's hosted popup just took, sent to us as well (BOAT-1894).
 *
 * The popup is Klaviyo's own form, injected by klaviyo.js, so the address it
 * collects never reaches our database on its own. It also fires at first
 * landing — the earliest moment we can see a visitor's UTMs — which makes it
 * the best identity anchor we have and the worst one to give away.
 *
 * The touch pair comes from OUR cookies rather than from Klaviyo's capture: the
 * live form (XeC3ns) has no hidden UTM fields, so Klaviyo records no
 * attribution of its own, and even if it did, a cookie we write on the visitor's
 * first tagged arrival is the only thing that survives them landing days before
 * they subscribe.
 */
export const klaviyoSignup = ({
  email,
  name,
  utm,
  first_touch_utm: firstTouchUtm,
}: {
  email: string
  name?: string
  utm?: UtmData
  first_touch_utm?: UtmData
}) =>
  fetchApi(`/klaviyo/signup`, {
    method: 'POST',
    body: {
      email,
      ...(name ? { name } : {}),
      ...(utm ? { utm } : {}),
      ...(firstTouchUtm ? { first_touch_utm: firstTouchUtm } : {}),
    },
  })
